// extracted by mini-css-extract-plugin
export var body = "_38-1";
export var bodyPadded = "_38-2";
export var chevron = "_38-4";
export var chevronOpen = "_38-5";
export var header = "_38-0";
export var icon = "_38-3";